<template>
  <div class="md:flex flex-wrap">
    <div class="services-box">
      <input
        type="checkbox"
        value="has_purchased_testing"
        v-model="selectedServices"
        class="w-5 h-5"
      >
      <div
        class="services-box-label"
        @click="selectService('has_purchased_testing')"
      >
        <div class="font-semibold opacity-75">Testing by Intertek</div>
        <div
          v-if="selectedServices.includes('has_purchased_testing')"
          class="text-sm opacity-50"
        >
          Intertek testing experts will get in touch with testing options.
        </div>
      </div>
    </div>
    <div class="services-box">
      <input
        type="checkbox"
        value="has_purchased_inspection"
        v-model="selectedServices"
        class="w-5 h-5"
      >
      <div
        class="services-box-label"
        @click="selectService('has_purchased_inspection')"
      >
        <div class="font-semibold opacity-75">
          Inspection by Intertek ($296.80{{cartProducts.length > 1 ? ` x ${cartProducts.length} products` : ''}})
        </div>
        <div
          v-if="selectedServices.includes('has_purchased_inspection')"
          class="text-sm opacity-50"
        >
          Intertek inspection team will follow-up with you offline.
        </div>
      </div>
    </div>
    <div class="services-box">
      <input
        type="checkbox"
        value="has_purchased_insurance"
        v-model="selectedServices"
        class="w-5 h-5"
      >
      <div
        class="services-box-label"
        @click="selectService('has_purchased_insurance')"
      >
        <div class="font-semibold opacity-75">
          Export Insurance ({{ subTotal * (3/100) | currency }})
        </div>
        <div
          v-if="selectedServices.includes('has_purchased_insurance')"
          class="text-sm opacity-50"
        >
          3% of total amount.
        </div>
      </div>
    </div>
    <div class="services-box">
      <input
        type="checkbox"
        value="has_signed_up_for_drs"
        v-model="selectedServices"
        class="w-5 h-5"
      >
      <div
        class="services-box-label"
        @click="selectService('has_signed_up_for_drs')"
      >
        <div class="font-semibold opacity-75">
          Become verified with DRS by Dun & Bradstreet ($723.00)
        </div>
        <div
          v-if="selectedServices.includes('has_signed_up_for_drs')"
          class="text-sm"
        >
          <span class="opacity-50">
            Improve your credibility with DRS now
          </span>
          <a
            @click.stop
            target="_blank"
            class="text-blue"
            href="https://www.dunsregistered.com/images/DRSBrochure.pdf"
          >Learn more</a>
        </div>
      </div>
    </div>
    <div class="services-box">
      <input
        type="checkbox"
        value="has_customization"
        v-model="selectedServices"
        class="w-5 h-5"
      >
      <div
        class="services-box-label font-semibold opacity-75"
        @click="selectService('has_customization')"
      >
        Order Customization
      </div>
    </div>
  </div>
</template>
<script>
import ProductDetails from '@/shared/mixins/ProductDetails'
export default {
  name: 'AddionalServices',
  mixins: [ ProductDetails ],
  props: {
    services: {
      type: Array
    },
    // subTotal: {
    //   required: true
    // },
    cartProducts: {
      required: true
    }
  },
  data() {
    return {
      selectedServices: [],
      customizationSelected: false
    }
  },
  created() {
    this.selectedServices = this.services
    var products = [];
    this.cartProducts.forEach((product) => {
        /*
        window.ga('ec:addProduct', {
          id: product.productId,                            // Transaction ID. Required.
          name: product.name,                       // Product name. Required. 
          sku: product.sku,                        // SKU/code.
          category: product.categoryName,         // Category or variation.
          quantity: product.quantity,
          price : this.calculateItemPrice(product),
          brand: product.brand
        });
        */
        products.push({
            id: product.productId,                            // Transaction ID. Required.
            name: product.name,                       // Product name. Required. 
            sku: product.sku,                        // SKU/code.
            category: product.categoryName,         // Category or variation.
            quantity: product.quantity,
            price : this.calculateItemPrice(product),
            brand: product.brand
        });
    });
    /*
    window.ga('ec:setAction','checkout', {
        'step': 2,            // A value of 1 indicates this action is first checkout step.
        'option': 'Additional Services'      // Used to specify additional info about a checkout stage, e.g. payment method.
    });
    window.ga('send', 'pageview');
    */
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      'event': 'checkout',
      'ecommerce': {
        'checkout': {
          'actionField': {'step': 2, 'option': 'Additional Services'},
          'products': products
        }
      }
    });
  },
  watch: {
    selectedServices() {
      this.$emit('changed', this.selectedServices)
    }
  },
  methods: {
    selectService(value) {
      if (this.selectedServices.includes(value)) {
        this.selectedServices.splice(this.selectedServices.indexOf(value), 1)
      } else {
        this.selectedServices.push(value)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .services-box {
    @apply flex pb-4 items-center justify-between h-16;
    @screen md { @apply w-1/2 justify-start }
    &-label {
      @apply w-11/12 pl-4 leading-4 cursor-pointer;
      @screen md { @apply w-auto; }
    }
  }
</style>